import SVGIcon, { type SVGIconProps } from "@ch/components/Icons/SVGIcon";
import type { FC } from "react";

type IconProps = Partial<SVGIconProps>;

const TwoFaIcon: FC<IconProps> = (props) => (
  <SVGIcon viewBox="0 0 20 20" {...props}>
    <svg
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path d="M17.425 9.268c0 4.075-2.958 7.892-7 9.008-.275.075-.575.075-.85 0-4.042-1.117-7-4.933-7-9.008V5.609c0-.683.517-1.458 1.158-1.717l4.642-1.9c1.042-.425 2.217-.425 3.258 0l4.642 1.9c.633.258 1.158 1.033 1.158 1.717l-.008 3.658z" />
      <g strokeMiterlimit="10">
        <path d="M10 10.417c.92 0 1.667-.746 1.667-1.667S10.92 7.084 10 7.084s-1.667.746-1.667 1.667.746 1.667 1.667 1.667z" />
        <path d="M10 10.418v2.5" strokeLinecap="round" />
      </g>
    </svg>
  </SVGIcon>
);

export default TwoFaIcon;
